<template>
    <div :id="['lightbox-' + identifierId]"
         class="d-flex flex-column justify-content-center align-items-center">
        <div class="form-modal-container d-flex flex-column justify-content-center align-items-center" style="color: white;">
            <div class="form-overlay-background"></div>
            <div class="default-form-template form-internal-container d-flex flex-column"
                 :class="[formSizeClass, formPosition]"
                 :id="['form-template-' + identifierId]">
                <header class="form-internal-head d-flex justify-content-end align-items-center"
                        :class="['class-template-close-' + identifierId]"
                        v-if="!formRequired">
                    <div aria-label="close" class="container-form-close"
                         @click="closeModal">
                        <div class="close-form-icon"></div>
                    </div>
                </header>
                <section class="form-internal-body">
                    <div :id="['divForm-' + identifierId]">
                        <div :class="['class-template-header-' + identifierId]">
                            <div class="container-logo text-center" id="logo"
                                 v-if="logo1 !== ''" v-html="logo1">
                            </div>
                            <div class="title_form">
                                <h3 class="my-1 my-lg-3 bold">{{ formTitle }}</h3>
                                <h5 class="mb-1 text-center">{{ formDescription }}</h5>
                            </div>
                        </div>
                        <div class="questions-container">
                            <div class="questions-internal-container">
                                <form :name="'form-' + identifierId"
                                      :id="'form-' + identifierId"
                                      @submit.prevent="submitHandler">
                                    <Questions
                                        :key="identifierId"
                                        :additional-percentage-height="additionalPercentageHeight"
                                        :existValueOther="existValueOther"
                                        :form-size-class="formSizeClass"
                                        :identifierId="identifierId"
                                        :input-text="inputText"
                                        :has-pages="false"
                                        :hotspot="hotspot"
                                        :pages="1"
                                        :question-image-required="questionImageRequired"
                                        :store="store"
                                        :translate-labels="translateLabels"
                                        :type-identifier="typeIdentifier"
                                        :form-errors="shouldShowErrors ? errors : {}"
                                        :has-submitted="hasSubmitted"
                                        @register-field="registerField"
                                        @field-change="handleFieldChange"
                                        @other-field-data="handleOtherFieldData"
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="form-internal-footer flex-column"
                     :class="['class-template-footer-' + identifierId]">
                    <div class="footer-alignment">
                        <div class="container-logo item-alignment-logo" id="logo"
                             v-if="logo1 !== ''"
                             v-html="logo1">
                        </div>
                        <div data-classification="button" data-type="submit" class="item-alignment-btn">
                            <div class="formulate-input-wrapper">
                                <div data-type="submit" class="form-input-element form-input-element--submit">
                                    <button type="button" class="btn btn_forms_tag button-submit"
                                    @click.prevent="submitHandler">
                                        <span class="form-input-element--submit--label">{{ translateLabels.textButtonSubmit }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="container-text-mandatory">
                        <label class="text-mandatory">{{ translateLabels.textMandatoryFields }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, nextTick } from 'vue';
import { useForm } from 'vee-validate';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import Questions from "@/playerVue3/components/form/questions.vue";
import {
  handleELearningRegistrationSubmit,
  prepareDataAndSave,
  replaceDataVariableInForm
} from '@/playerVue3/services/form-service'

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    configurationData: {
        type: String,
        required: false,
    },
    formDescription: {
        type: String,
        required: true,
    },
    formPosition: {
        type: String,
        required: false,
        default: 'top_right',
    },
    formRequired: {
        type: Boolean,
        required: false,
        default: false,
    },
    formSizeClass: {
        type: String,
        required: false,
        default: 'large-form-modal-container',
    },
    formTitle: {
        type: String,
        required: true,
    },
    hotspot: {
        type: Object,
        required: false,
    },
    hotspotEmailTemplateId: {
        type: Number,
        required: false,
    },
    identifierId: {
        type: Number,
        required: true,
    },
    store: {
        type: Object,
        required: true
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    typeIdentifier: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['setClose']);

// VeeValidate form setup con configuración lazy
const { validate, values, errors, setFieldValue, submitCount } = useForm({
    validateOnMount: false,    // No validar al montar
    initialValues: {},
});

// REACTIVE VARIABLES
const additionalPercentageHeight = ref(0);
const existValueOther = ref(false);
const inputText = ref(false);
const questionImageRequired = ref(false);
const hasSubmitted = ref(false); // Flag para rastrear si ya se envió
const otherFieldsData = ref({}); // Nuevo: almacenar datos de campos "other"

const fields = ref({
    formID: playerStore.getFormID,
    formIsFromAttrAdditional: false,
    hotspotEmailTemplateID: props.hotspotEmailTemplateId,
    hotspotID: props.typeIdentifier === 'form' ? 0 : props.identifierId,
    vID: playerStore.getVideoID,
    wlID: playerStore.getWeblinkID,
});

// COMPUTED PROPERTIES
const logo1 = computed(() => {
    if (props.configurationData) {
        const configurationData = JSON.parse(props.configurationData);
        if (configurationData.logo1) {
            const weblinkID = playerStore.getWeblinkID;
            if (configurationData.logo1.variableName !== '' && weblinkID > 0) {
                return replaceDataVariableInForm(playerStore, props.hotspot, configurationData.logo1);
            } else {
                return '<img class="img-fluid img-logo" alt="V2M" src="'+ configurationData.logo1.url + '">';
            }
        }
    }
    return '';
});

// Computed para saber si mostrar errores
const shouldShowErrors = computed(() => hasSubmitted.value);

// METHODS
const closeModal = () => {
    emit('setClose');
};

const registerField = (fieldName, fieldValue = '') => {
    setFieldValue(fieldName, fieldValue, false); // false = no validar inmediatamente
};

const handleFieldChange = (fieldName, value) => {
    setFieldValue(fieldName, value, hasSubmitted.value); // Solo validar si ya se envió
};

const handleOtherFieldData = (data) => {
    const key = `question_${data.quetionType}_${data.questionId}_${data.optionId}_text_other`;

    if (data.isSelected && data.otherValue) {
        otherFieldsData.value[key] = data.otherValue;
    } else {
        delete otherFieldsData.value[key];
    }
};

const submitHandler = async () => {
    hasSubmitted.value = true;

    // Disparar validación
    const { valid, errors } = await validate();

    if (valid) {
        // Serializar datos del formulario
        const formDataSerialize = Object.entries(values).map(([name, value]) => ({
            name,
            value
        }));

        // Agregar datos adicionales de campos "other"
        Object.entries(otherFieldsData.value).forEach(([key, data]) => {
            formDataSerialize.push({
                name: key,
                value: data
            });
        });

        // necesito ordenar el contenido de formDataSerialize por el name para que los campos other esten al final
        formDataSerialize.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        const isRegister = playerStore.isActiveHotspotRegistration

        if (isRegister) {
          await handleELearningRegistrationSubmit(playerStore, fields.value, formDataSerialize);
        } else{
          await prepareDataAndSave(playerStore, fields.value, formDataSerialize);
        }

        closeModal();
    } else {
        // Lógica si la validación falla (formulario dinámico)

        // Esperamos a que Vue actualice el DOM (ej. renderizar textos de error)
        await nextTick();

        // Obtenemos el nombre del primer campo dinámico que falló
        const primerCampoConError = Object.keys(errors)[0];
        if (primerCampoConError) {
            // Buscamos el elemento interactivo en el DOM
            const elemento = document.querySelector(`[name="${primerCampoConError}"]`);

            if (elemento) {
                // Movemos el foco
                elemento.focus();

                // Hacemos scroll centrado para mejor experiencia de usuario
                elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                console.warn(`No se encontró un elemento HTML con el name="${primerCampoConError}" para enfocar.`);
            }
        }
    }
};

// LIFECYCLE HOOKS
</script>
